import { FC } from "react";
import { ProcessExecution } from "../../../model/ProcessExecution";
import { HumanReadableTimestamp } from "../../../components";

const ProcessExecutionUpdated: FC<ProcessExecution> = (processExecution) => {
  return <HumanReadableTimestamp timestamp={processExecution.updated_at} />;
};

export default ProcessExecutionUpdated;
